import { avatarGroupClasses, type ThemeOptions } from '@mui/material';

export function createAvatarGroupStyles() {
  return {
    MuiAvatarGroup: {
      styleOverrides: {
        root: () => ({
          [`& .${avatarGroupClasses.avatar}`]: {
            height: '32px',
            width: '32px',
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
